import { Doughnut, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: {},
    },
    options: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    semiCircle: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    chartData() {
      this.$data._chart.update();
      // this.renderChartReport();
      // this.$data._chart.update();
    },
  },
  mounted() {
    // this.$data._chart.destroy();
    this.renderChartReport();
  },
  methods: {
    renderChartReport() {
      const options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: "top",
        },
        title: {
          display: true,
          text: this.title,
        },
        animation: {
          animateScale: true,
          animateRotate: true,
        },
      };
      if (this.semiCircle) {
        options["rotation"] = 1 * Math.PI;
        options["circumference"] = 1 * Math.PI;
      }
      // this.$data._chart.destroy();
      this.renderChart(this.chartData, options);
      // this.$nextTick(() => {
      //   this.$data._chart.update();
      // });
    },
  },
};
